/**
 * 
 */
;
(function(){
	"use strict";
	angular.module("cbl.cartadebitoint.wa.directives", ["cbl.common"]);
	
}());


//////////////////
// WEBPACK FOOTER
// ./app/widgets/cdint.directives.js
// module id = 29
// module chunks = 0